import React from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { FaInfoCircle } from 'react-icons/fa';

const propTypes = {
    icd10: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string,
            code: PropTypes.string,
            name: PropTypes.string,
            shortDescription: PropTypes.string,
        })
    ),
    icd10Merged: PropTypes.string,
};

const defaultProps = {
    icd10: [],
    icd10Merged: '',
};

function ICD10Popover({ icd10, icd10Merged }) {
    const ICD10Icon = (
        <Popover id="icd10Popover" className="increase-popover-width">
            <Popover.Content>
                {icd10.length
                    ? icd10.map((item) => {
                          return <div key={item.id}> {`${item.code} - ${item.name || item.shortDescription}`}</div>;
                      })
                    : ''}
            </Popover.Content>
        </Popover>
    );

    return (
        <span className="icd10-popover-trigger">
            <strong>{`${icd10Merged.substring(0, 40)} (...)`}</strong>
            <OverlayTrigger trigger="click" rootClose placement="bottom" overlay={ICD10Icon}>
                <button
                    type="button"
                    aria-label="Show ICD-10 diagnosis codes"
                    style={{ background: 'none', border: 0, padding: 0, cursor: 'pointer', marginLeft: 3 }}
                >
                    <FaInfoCircle aria-hidden="true" focusable="false" />
                </button>
            </OverlayTrigger>
        </span>
    );
}

ICD10Popover.propTypes = propTypes;
ICD10Popover.defaultProps = defaultProps;

export default ICD10Popover;
